import { render, staticRenderFns } from "./AdmissionProfileView.vue?vue&type=template&id=9ac1bd08&scoped=true"
import script from "./AdmissionProfileView.vue?vue&type=script&lang=js"
export * from "./AdmissionProfileView.vue?vue&type=script&lang=js"
import style0 from "./AdmissionProfileView.vue?vue&type=style&index=0&id=9ac1bd08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac1bd08",
  null
  
)

export default component.exports